import { useCallback, useEffect, useState } from 'react'
import { Checkbox, Flex } from '@chakra-ui/react'
import { AllRoleTypes, RoleType } from 'entities/job'
import { append } from 'lib/array'
import { FilterInput } from 'containers/jobs-board/components/FilterInput'
import { useJobsSearchContext } from 'containers/jobs-board/context/JobsSearchContext'

export const RoleTypeFilter = () => {
    const { filters, updateFilters } = useJobsSearchContext()

    const [selectedRoleTypes, setSelectedRoleTypes] = useState<RoleType[]>(
        filters.roleTypes ?? [],
    )
    useEffect(() => {
        setSelectedRoleTypes(filters.roleTypes ?? [])
    }, [filters.roleTypes])

    const handleOnChange = useCallback(
        (value: RoleType) => {
            if (selectedRoleTypes?.includes(value)) {
                const roleTypes = selectedRoleTypes.filter(p => p !== value)
                updateFilters({
                    roleTypes: roleTypes.length === 0 ? undefined : roleTypes,
                })
            } else {
                updateFilters({ roleTypes: append(selectedRoleTypes, value) })
            }
        },
        [selectedRoleTypes],
    )

    return (
        <FilterInput label="Role type" minWidth="210px">
            <Flex direction="column" gridGap="24px">
                <Checkbox
                    isChecked={selectedRoleTypes?.includes(AllRoleTypes.FullTime)}
                    onChange={() => handleOnChange(AllRoleTypes.FullTime)}
                >
                    Full time
                </Checkbox>
                <Checkbox
                    isChecked={selectedRoleTypes?.includes(AllRoleTypes.Contract)}
                    onChange={() => handleOnChange(AllRoleTypes.Contract)}
                >
                    Contract
                </Checkbox>
                <Checkbox
                    isChecked={selectedRoleTypes?.includes(AllRoleTypes.Intern)}
                    onChange={() => handleOnChange(AllRoleTypes.Intern)}
                >
                    Intern
                </Checkbox>
            </Flex>
        </FilterInput>
    )
}
